module.exports = __webpack_public_path__ + "static/media/departure-icon.cd81beb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/departure-icon.svg
// module id = 404
// module chunks = 0